import { BusinessUnitsModelAPI } from '../../../../models';
import { getBusinessUnitsListAdapter } from '../../Adapters/business-units/BusinessUnits.adapter';
import { requests } from '../apiAgent';

export const BusinessUnitsAPI = {
    getBusinessUnits: () => {
        return requests
            .get('/jerusalem/api/v2.0.0/business-units')
            .then((response: BusinessUnitsModelAPI[]) =>
                getBusinessUnitsListAdapter(response)
            );
    },
};
